import { SVG_RenderChartBox } from "./SVG_RenderChartBox";
import { kRoundRectRadius, enumFillMode } from "../constants";

export function SVG_DrawDisabledChartBox(chartBox, svgElement) {
  var r = chartBox.GetAdjBounds(kRoundRectRadius);
  var r2 = chartBox.GetOuterBorder(r, kRoundRectRadius);
  if (chartBox.GetDataObj())
    SVG_RenderChartBox(
      r,
      r2,
      chartBox.GetBoxShapeType(),
      enumFillMode.opacityfill,
      "#777777",
      false,
      false,
      false,
      false,
      false,
      svgElement,
      false
    );
}
